"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _popover = _interopRequireDefault(require("./shared/popover"));

require("../css/tooltip.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Content = function Content(_ref) {
  var content = _ref.content;
  return _react.default.createElement("span", null, _react.default.createElement("div", {
    className: "vn-tooltip__content"
  }, content));
};

Content.propTypes = {
  content: _propTypes.default.node.isRequired
};

var Tooltip = function Tooltip(_ref2) {
  var children = _ref2.children,
      content = _ref2.content,
      tabIndex = _ref2.tabIndex,
      role = _ref2.role,
      otherProps = _objectWithoutProperties(_ref2, ["children", "content", "tabIndex", "role"]);

  return _react.default.createElement(_popover.default, _extends({}, otherProps, {
    arrow: true,
    className: "vn-tooltip",
    content: _react.default.createElement(Content, {
      content: content
    }),
    interactionType: _reactDeviceDetect.isMobile ? 'click' : 'hover',
    targetClassName: "vn-tooltip__target",
    targetRole: role,
    targetTabIndex: tabIndex
  }), children);
};

Tooltip.propTypes = {
  alignment: _propTypes.default.oneOf(_popover.default.alignmentOptions),
  children: _propTypes.default.node.isRequired,
  content: _propTypes.default.node.isRequired,
  contentHideDelayOnHover: _propTypes.default.number,
  contentShowDelayOnHover: _propTypes.default.number,
  placement: _propTypes.default.oneOf(_popover.default.placementOptions),
  position: _propTypes.default.oneOf(_popover.default.positionOptions),
  role: _propTypes.default.string,
  tabIndex: _propTypes.default.number,
  useJsPositioning: _propTypes.default.bool
};
Tooltip.defaultProps = {
  alignment: 'left',
  contentHideDelayOnHover: 300,
  contentShowDelayOnHover: 0,
  placement: 'manual',
  position: 'down',
  role: undefined,
  tabIndex: undefined,
  useJsPositioning: false
};
Tooltip.displayName = 'Tooltip';
var _default = Tooltip;
exports.default = _default;